class PredictiveSearch extends HTMLFormElement {
  constructor() {
    super();
    this.cachedMap = new Map();
    this.focusElement = this.input;
    this.resetButton.addEventListener('click', this.clear.bind(this));
    this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';

    const isTemplateSearch = this.closest('.template-search');
    if (isTemplateSearch) {

    }
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }
  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  onFocus(event) {
    if (this.closest('.template-search')) {
      document.body.classList.add('predictive-search-open');
      if (this.getQuery().length === 0) {
        return;
      }
      const url = this.setupURL().toString();
      this.renderSection(url, event);
    }
  }
  getQuery() {
    return this.input.value.trim();
  }
  clear(event = null) {
    event && event.preventDefault();
    if (this.searchRecommendationEmpty && this.searchContent) {
      this.searchContent.classList.add('hidden');
    }
    this.input.value = '';
    this.input.focus();
    this.removeAttribute('results');
  }

  setupURL() {
    const url = new URL(`${FoxTheme.routes.shop_url}${FoxTheme.routes.predictive_search_url}`);
    return (
      url.searchParams.set('q', this.getQuery()),
      url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3),
      url.searchParams.set('resources[limit_scope]', 'each'),
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this)),
      url
    );
  }

  onChange() {
    if (this.getQuery().length === 0) {
      this.clear();
      return;
    }
    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  renderSection(url) {
    this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
  }

  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.renderSearchResults(responseText), this.setAttribute('results', '');
  }

  renderSectionFromFetch(url) {
    // Indicate that loading has started
    this.setAttribute('loading', 'true');
    this.resetButton.classList.add('btn--loading');

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((responseText) => {
        // Process and cache the fetched data
        this.renderSearchResults(responseText);
        this.cachedMap.set(url, responseText);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
        this.setAttribute('error', 'Failed to load data');
      })
      .finally(() => {
        // Remove the loading attribute in both success and error cases
        this.removeAttribute('loading');
        this.resetButton.classList.remove('btn--loading');
        this.setAttribute('results', 'true');
      });
  }
  renderSearchResults(responseText) {
    const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
    const targetElement = document.getElementById(id);

    if (targetElement) {
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(responseText, 'text/html');
      const contentElement = parsedDoc.getElementById(id);

      if (contentElement) {
        this.searchContent?.classList.remove('hidden');
        targetElement.innerHTML = contentElement.innerHTML;
      } else {
        console.error(`Element with id '${id}' not found in the parsed response.`);
      }
    } else {
      console.error(`Element with id '${id}' not found in the document.`);
    }
  }
}
customElements.define('predictive-search', PredictiveSearch, { extends: 'form' });

class SearchDrawer extends DrawerComponent {
  constructor() {
    super();
  }
  get requiresBodyAppended() {
    return false;
  }
  get input() {
    return this.querySelector('input[type="search"]');
  }
  get focusElement() {
    return this.querySelector('input[type="search"]');
  }
}
customElements.define('search-drawer', SearchDrawer);

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.search-drawer-button');
  if (!btn) return;

  const icon = btn.querySelector('.search-drawer-button__icon');
  const spinner = btn.querySelector('.search-drawer-button__spinner');
  if (!icon || !spinner) return;

  icon.style.display = 'none';
  spinner.removeAttribute('hidden');
  spinner.style.display = 'inline-block';

  let observer;
  const dfdRoot = document.querySelector('.dfd-root');
  if (dfdRoot) {
    observer = new MutationObserver(() => {
      if (!dfdRoot.hidden) {
        icon.style.display = '';
        spinner.style.display = 'none';
        observer.disconnect();
      }
    });
    observer.observe(dfdRoot, { attributes: true, attributeFilter: ['hidden'] });
  }

  setTimeout(() => {
    icon.style.display = '';
    spinner.style.display = 'none';
    if (observer) observer.disconnect();
  }, 5000);
}, true);

(function observeDoofinder() {
  const dfdRoot = document.querySelector('.dfd-root');
  if (!dfdRoot) {
    setTimeout(observeDoofinder, 500);
    return;
  }
  const searchDrawer = document.getElementById('SearchDrawer');
  if (!searchDrawer) return;

  // Scroll-lock opruimen als Doofinder dicht is. De drawer zet bij openen
  // 'modal-showing' op <body> en haalt die pas weg na zijn eigen
  // open-animatie; opent Doofinder daar bovenop (en sluit hij weer) voordat
  // die animatie klaar is, dan bleef <body> op overflow:hidden staan.
  const releaseScrollLock = () => {
    if (!dfdRoot.hidden) return;
    const openModal = Array.from(document.querySelectorAll('[open]')).some(
      (el) => typeof ModalComponent !== 'undefined' && el instanceof ModalComponent
    );
    if (openModal) return;
    document.body.classList.remove('modal-showing', 'modal-show');
    document.documentElement.classList.remove('dfd-fixed-layout');
    if (typeof clearModalComponentCount !== 'undefined' && typeof ModalComponent !== 'undefined') {
      clearModalComponentCount.set(ModalComponent, 0);
    }
  };

  new MutationObserver(() => {
    if (!dfdRoot.hidden) return;
    if (searchDrawer.hasAttribute('open')) {
      searchDrawer.removeAttribute('open');
      searchDrawer.setAttribute('aria-hidden', 'true');
      document.querySelectorAll('[aria-controls="SearchDrawer"]').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
      });
    }
    // Na de sluit-animatie van de drawer (0,8s) controleren.
    setTimeout(releaseScrollLock, 1000);
  }).observe(dfdRoot, { attributes: true, attributeFilter: ['hidden'] });
})();

const searchContainer = document.querySelector('.header-main__search');
if (searchContainer) {
  const input = searchContainer.querySelector('form input[type="search"]');

  let downInside = false;

  // Track where the pointer went down
  document.addEventListener('pointerdown', (e) => {
    downInside = searchContainer.contains(e.target);
  }, true);

  if (input) {
    input.addEventListener('focus', () => {
      searchContainer.classList.add('header-main__search--popup');
    });

    input.addEventListener('blur', () => {
      requestAnimationFrame(() => {
        // If the pointer started inside (e.g. clicking a result), don’t close
        if (downInside) {
          downInside = false;
          return;
        }

        const active = document.activeElement;
        const stillInside = active && searchContainer.contains(active);

        if (!stillInside) {
          searchContainer.classList.remove('header-main__search--popup');
        }
      });
    });
  }
}

